/**
 * @fileoverview POST handler for the "/generative_ai/gpt_assistant" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiGptAssistantCacheKeys } from "./constants";
import type { PostGenerativeAiGptAssistantProps, GenerativeAiGptAssistantResult } from "./types";

export const postGenerativeAiGptAssistant = reactQueryMutationAdapter(
  generativeAiGptAssistantCacheKeys,
  (props: PostGenerativeAiGptAssistantProps): Promise<GenerativeAiGptAssistantResult> => {
    return fetch(
      "/generative_ai/gpt_assistant",
      "POST",
      {
        copy: props.copy,
        language_code: props.languageCode,
        length_type: props.lengthType,
        message_type: props.messageType,
        use_campaign_data: props.useCampaignData,
        tone_type: props.toneType,
        temporary_guideline: props.temporaryGuideline,
        brand_guideline_id: props.brandGuidelineId,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
